<template>
  <main>
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section class="levels">
      <h1>{{ getTranslations.home_levels }}</h1>

      <div class="lvl_sect">
        <div class="lvl_banner lvl_1">
          <div class="lvl_text">
            <h3>{{ getTranslations.home_level_1 }} <b>{{ getTranslations.home_level_title_1 }}</b></h3>
            <p>{{ getTranslations.home_level_desc_1_small }}</p>
          </div>
        </div>
        <p class="lvl_desc">
          {{ getTranslations.home_level_desc_1 }}
        </p>
      </div>

      <div class="lvl_sect mt-50">
        <div class="lvl_banner lvl_2">
          <div class="lvl_text">
            <h3>{{ getTranslations.home_level_2 }} <b>{{ getTranslations.home_level_title_2 }}</b></h3>
            <p>{{ getTranslations.home_level_desc_2_small }}</p>
          </div>
        </div>
        <p class="lvl_desc">
          {{ getTranslations.home_level_desc_2 }}
        </p>
      </div>

      <div class="lvl_sect mt-50">
        <div class="lvl_banner lvl_3">
          <div class="lvl_text">
            <h3>{{ getTranslations.home_level_3 }} <b>{{ getTranslations.home_level_title_3 }}</b></h3>
            <p>{{ getTranslations.home_level_desc_3_small }}</p>
          </div>
        </div>
        <p class="lvl_desc">
          {{ getTranslations.home_level_desc_3 }}
        </p>
      </div>

      <div class="lvl_sect mt-50">
        <div class="lvl_banner lvl_4">
          <div class="lvl_text">
            <h3>{{ getTranslations.home_level_4 }} <b>{{ getTranslations.home_level_title_4 }}</b></h3>
            <p>{{ getTranslations.home_level_desc_4_small }}</p>
          </div>
        </div>
        <p class="lvl_desc">
          {{ getTranslations.home_level_desc_4 }}
        </p>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'levels',

  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Levels.vue